import React, {  useContext } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'

// Gird system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField } from '../../../components/FormElements/FormElements'

// Stylesheet
// import './ManageAttributes.css'
import { priceResponse }  from '../../../services/api/api'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { editPricingSlice, editPricingState } from './EditPricingSlice'
import { productsSlice } from '../PricingSlice';
import { AxiosError, AxiosResponse } from 'axios'
import SettingContext from '../../../services/context/setting-contentxt/setting-context'

import { useAPI } from '../../../services/hoc/useAPI'
export default ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const {isMobile ,isPc} = useContext(SettingContext)
    const state = useSelector((state: { edit_pricing: editPricingState }) => state.edit_pricing)

   const ENDPOINTS = useAPI()



    const toggle = () => {
        dispatch(editPricingSlice.actions.setIsOpen(!state.isOpen))
        dispatch(editPricingSlice.actions.init())
        close()
    }

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        dispatch(editPricingSlice.actions.setIsLoading(true))
        ENDPOINTS.pricing().updateGlassPrices({ prices: state.prices })
        .then((response: AxiosResponse<{data:priceResponse[]}>) => {

           let price= response.data.data.filter((ele:any)=>ele.pid === state.prices[0].id)[0]
      
            dispatch(editPricingSlice.actions.setIsLoading(false))
            dispatch(editPricingSlice.actions.setIsSuccess(true))
    
            if (price) {dispatch(productsSlice.actions.updateprice(price))}
            setTimeout(() => {
                toggle()
                dispatch(editPricingSlice.actions.setIsOpen(false))
            }, 1000);
        }).
        catch((err:AxiosError)=>{
             dispatch(editPricingSlice.actions.setIsLoading(false))
            dispatch(editPricingSlice.actions.setIsSuccess(false))

             setTimeout(() => {
                toggle()
                dispatch(editPricingSlice.actions.setIsOpen(false))
            }, 1000);
        })
    }

    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("pricing")}</h2>

            <form onSubmit={submit} style={{ width:isPc? "450px":isMobile?'280px':'450px' }}>

                <div className="attribute">
                    <div className="attribute-fields" style={state.prices.length > 1 ? {} : { padding: 0 }}>
                        <Row>

                            <Col md={12}>
                                <InputField
                                    type="number"
                                    label={t("price")}
                                    value={state.prices[0].price}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        dispatch(editPricingSlice.actions.setPriceValue(e.target.value));
                                    }}
                                />
                            </Col>

                        </Row>
                    </div>
                </div>

                <button className="button round bg-gold color-white margin-top-20"
                 style={{ padding:isMobile? "0 40px" :"0 80px", marginBottom: 5 }} >{t("submit")}</button>

            </form>

        </Modal>
    );
}